export default "__VITE_ASSET__9eac1321__"